import { ASYNC, SYNC, actionTypes } from "../utils"

const types = actionTypes({
  items: {
    FETCH_ICONS: ASYNC,
    FETCH_ITEMS: ASYNC,
    FETCH_ITEM_BY_SLUG: ASYNC,
    FETCH_ITEM_BY_SLUG_AND_LANGUAGE: ASYNC,
    FETCH_ALL_NON_LEAF_ITEMS: ASYNC,
    FETCH_ITEM_LANGUAGES: ASYNC,
    FETCH_ITEM_VERSIONS: ASYNC,
    CLEAR_FETCHED_ITEMS: SYNC,
    SELECT_ITEM: SYNC,
    CLEAR_SELECTED_ITEM: SYNC,
    CREATE_ITEM: ASYNC,
    CREATE_ITEM_DRAFT: ASYNC,
    CREATE_ITEM_TRANSLATION: ASYNC,
    CREATE_ITEM_FROM_WORD: ASYNC,
    CREATE_ITEM_VARIANT: ASYNC,
    CREATE_ITEM_VARIANT_DRAFT: ASYNC,
    UPDATE_ITEM: ASYNC,
    TRANSLATE_ITEM: ASYNC,
    LOCK_ITEM: ASYNC,
    UNLOCK_ITEM: ASYNC,
    REORDER_ITEMS: ASYNC,
    MOVE_ITEM: ASYNC,
    DELETE_FILE: ASYNC,
    UPLOAD_FILE: ASYNC,
    SAVE_DRAFT: ASYNC,
    GET_LATEST_DRAFT: ASYNC,
    PRE_PUBLISH_MINOR_VERSION: ASYNC,
    PRE_PUBLISH_MAJOR_VERSION: ASYNC,
    PUBLISH_MINOR_VERSION: ASYNC,
    PUBLISH_MAJOR_VERSION: ASYNC,
    PUBLISH_ITEM: ASYNC,
    ARCHIVE_ITEM: ASYNC,
    REMOVE_ITEM_FROM_CONFIGURATOR: ASYNC,
    UNARCHIVE_ITEM: ASYNC,
    SET_CURRENT_PAGE_ITEM: SYNC,
    TOGGLE_PROCEDURE_EDIT_MODE: SYNC,
    FAVORITES: {
      FETCH: ASYNC,
      ADD: ASYNC,
      UPDATE: ASYNC,
      REMOVE: ASYNC,
    },
    AUDITS: {
      CLEAR: SYNC,
      FETCH: ASYNC,
      FETCH_ALL: ASYNC,
      SET_TOKEN: SYNC,
    },
    SERVICELINES: {
      FETCH: ASYNC,
    },
    FETCH_CHANGELOG: ASYNC,
    AUTO_TRANSLATE_ITEM: ASYNC,
    RESET_AUTO_TRANSLATE_ITEM: SYNC,
    AUTO_TRANSLATE_ITEM_DETAILS: ASYNC,
    UPDATE_AUTO_TRANSLATE_ITEM_DETAILS: SYNC,
    UPDATE_AUTO_TRANSLATE_ITEM_STEP_DETAILS: SYNC,
    RESET_AUTO_TRANSLATE_ITEM_STEP_DETAILS: SYNC,
    AUTO_TRANSLATE_ITEM_FOR_LANGUAGE: ASYNC,
    LAST_TRANSLATE_ITEM: ASYNC,
    FETCH_VERSIONS: ASYNC,
    FETCH_VERSION_LEFT: ASYNC,
    FETCH_VERSION_RIGHT: ASYNC,
    RESET_COMPARE: SYNC,
    EXIT_COMPARE_MODE: SYNC,
    SUBSCRIBE_TO_NOTIFICATION: ASYNC,
    UNSUBSCRIBE_FROM_NOTIFICATION: ASYNC,
  },
})

export default types.items
